export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><path d=\"M10.246 3L2.023 8.369l5.686 4.553L16 7.802zM2.023 17.475l8.223 5.369L16 18.042l-8.291-5.12zM16 18.042l5.754 4.802 8.223-5.369-5.686-4.553zm13.977-9.673L21.754 3 16 7.802l8.291 5.12z\" fill=\"#3F4450\"/><path d=\"M16.017 19.075l-5.771 4.788-2.469-1.612v1.808L16.017 29l8.24-4.941v-1.808l-2.469 1.612z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};